export const SEARCH_SNAKE_KEYS_EXCLUDE = [
  'prepaid_sum__gte',
  'prepaid_sum__lte',
  'monthly_payment__gte',
  'monthly_payment__lte',
];



// WEBPACK FOOTER //
// ./src/shared/constants/search.js